import {SIOConstants} from "@game/constants";

export const enum ShopType {
    BUILDING = "ShopType.BUILDING",
    FIGHTER = "ShopType.FIGHTER",
    COLOR = "ShopType.COLOR",
    STARS = "ShopType.STARS"
}

export const UIConstants = {
    tapToPlayButton: {
        showGoDelay: 200,
        hideDelay: 800
    },
    coinsIndicator: {
        updateDelay: 350
    },
    popup: {
        startDelay: 100,
        noThanksButtonDelay:
            __SOCIAL__ === "ya" || __SOCIAL__ === "yt" || __SOCIAL__ === "ls" ? 0 : 2000,
        updateCoinsTime: 800,
        updateCoinsInterval: 25
    },
    boosters: [
        {
            id: "BoosterType.START_UNITS",
            className: "booster-start-units",
            icon: "",
            disabled: true,
            defaultCount: 10,
            title: {
                i18n: "ui-upgrade-start_units",
                default: "START UNITS"
            },
            description: {
                i18n: "ui-upgrade-units",
                default: "units"
            },
            allowed: true
        },
        {
            id: "BoosterType.START_PRODUCE",
            className: "booster-produce-speed",
            disabled: false,
            icon: "",
            defaultCount: "10",
            title: {
                i18n: "ui-upgrade-produce_speed",
                default: "PRODUCE SPEED"
            },
            description: {
                i18n: "ui-upgrate-rate",
                default: "units per second"
            },
            allowed: true
        },
        {
            id: "BoosterType.OFFLINE_EARNINGS",
            className: "booster-offline-earnings",
            icon: "",
            defaultCount: 10,
            disabled: false,
            title: {
                i18n: "ui-offline-title",
                default: "OFFLINE EARNINGS"
            },
            description: {
                i18n: "ui-upgrade-offline",
                default: "coins per hour"
            },
            allowed: SIOConstants.OFFLINE_EARNINGS_ALLOWED
        }
    ],
    shop: {
        tabTypes: __SOCIAL__ === "tg"
            ? [ShopType.BUILDING, ShopType.FIGHTER, ShopType.COLOR, ShopType.STARS]
            : [ShopType.BUILDING, ShopType.FIGHTER, ShopType.COLOR],
        defaultTabType: ShopType.BUILDING
    }
};
